module.exports = __webpack_public_path__ + "static/media/Avatars_Male-04.4aa9f492.png";